import React from "react";
import { FormattedMessage } from "react-intl";
//console.log('Management testType =>'+testType);
const renderSelected = (data, order, testType) => {
  let name1 = "name" + order[0];
  let name2 = "name" + order[1];
  let desc1 = "desc" + order[0];
  let desc2 = "desc" + order[1];
  let label1 = "label" + order[0];
  let label2 = "label" + order[1];
  if(testType === 'individual'){        /// check type of test individual or professional
    //console.log('Inside  individual  =>'+testType);    
    return (
      <React.Fragment>
        <div className="row mb-2">
          <div className="col-md-3 bg-info text-white d-flex align-items-center font-weight-bold p-3">
            {data[name1]}
          </div>
          <div className="col-md-6 p-0 border px-2 text-justify">
            <b><FormattedMessage id="ind.target.result.management.approaches" defaultMessage="Management approach of a"/> {data[name1]} : </b> {data[desc1]}
          </div>
          <div className="col-md-3 bg-info text-white d-flex align-items-center">
            {data[label1]}
          </div>
        </div>    
      </React.Fragment>
    );
  }else{
    //console.log('Inside  Professional  =>'+testType);
    return (
      <React.Fragment>
        <div className="row mb-2">
          <div className="col-md-2 display-3 text-center res-display">N° 1</div>
          <div className="col-md-3 bg-info text-white d-flex align-items-center font-weight-bold p-3">
            {data[name1]}
          </div>
          <div className="col-md-5 p-0 border px-2 text-justify">
            <b><FormattedMessage id="ind.target.result.management.approaches" defaultMessage="Management approach of a"/> {data[name1]} : </b> {data[desc1]}
          </div>
          <div className="col-md-2 bg-info text-white d-flex align-items-center">
            {data[label1]}
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-md-2 display-4 text-center res-display">n° 2</div>
          <div className="col-md-3 bg-info text-white d-flex align-items-center font-weight-bold p-3">
            {data[name2]}
          </div>
          <div className="col-md-5 p-0 border px-2 text-justify">
            <b><FormattedMessage id="ind.target.result.management.approaches" defaultMessage="Management approach of a"/> {data[name2]} : </b> {data[desc2]}
          </div>
          <div className="col-md-2 bg-info text-white d-flex align-items-center">
            {data[label2]}
          </div>
        </div>
      </React.Fragment>
    );
  }
};

const renderUnSelected = (data, order2, testType) => {
  //console.log(' renderUnSelected  '+testType);
  if(testType !== 'individual'){ /// check type of test individual or professional
    let name1 = "name" + order2[0];
    let desc1 = "desc" + order2[0];
    let name2 = "name" + order2[1];
    let desc2 = "desc" + order2[1];
    return (
      <React.Fragment>
        <div className="row mb-2">
          <div className="col-md-2" />        
          <div className="col-md-3 grey-bg d-flex align-items-center font-weight-bold p-3">
            {data[name1]}
          </div>
          <div className="col-md-5 p-0 border px-2 text-justify">
            <b><FormattedMessage id="ind.target.result.management.approaches" defaultMessage="Management approach of a"/> {data[name1]} : </b> {data[desc1]}
          </div>
          <div className="col-md-2" />
        </div>
        <div className="row mb-2">
          <div className="col-md-2" />        
          <div className="col-md-3 grey-bg d-flex align-items-center font-weight-bold p-3">
            {data[name2]}
          </div>
          <div className="col-md-5 p-0 border px-2 text-justify">
            <b><FormattedMessage id="ind.target.result.management.approaches" defaultMessage="Management approach of a"/> {data[name2]} : </b> {data[desc2]}
          </div>
          <div className="col-md-2" />                
        </div>
      </React.Fragment>
    );
  }
};

const renderFooter = (data, order) => {
  let word = "name" + order[0];
  let word2 = "name" + order[1];
  return (
    <React.Fragment>
      <div className="alert alert-secondary">
      <FormattedMessage id="ind.target.result.preffered.working1" defaultMessage="I prefer working of my own, in a"/> ‘ <b>{data[word]} </b>’, 
      <FormattedMessage id="ind.target.result.preffered.working2" defaultMessage="I’m also working in a"/> ‘ <b> {data[word2]} </b> ’.
      </div>
    </React.Fragment>
  );
};

function ManagementResult(props) {
  return (
    // <div className="col-lg-10 col-md-10 col-sm-12 m-auto">
    <div className="m-auto">
        {props.testType === 'individual' && ( /// check type of test individual
          <h4 className="text-center mb-1 mt-5">
            <FormattedMessage id="ind.target.your.work.management.result.title" defaultMessage="Your work management"/>
          </h4>
        )}
        {props.testType !== 'individual' && ( /// check type of test professional
          <h4 className="text-center mb-1 mt-5">
            <FormattedMessage id="ind.target.work.management.result.title" defaultMessage="Work management"/>
          </h4>
        )}
      <div className="card">
        {props.testType !== 'individual' && ( /// check type of test individual or professional        
          <div className="card-header">
            <FormattedMessage id="ind.target.two.preffered.approaches" defaultMessage="MY TWO PREFERED MANAGEMENT APPROACHES"/>                        
          </div>
        )}
        <div className="card-body">
          {renderSelected(props.result.top, props.result.order, props.testType)}
          {renderUnSelected(props.result.bottom, props.result.order2, props.testType)}
        </div>
        {props.testType !== 'individual' && ( /// check type of test individual or professional                
          <div className="card-footer text-muted text-center">
            {renderFooter(props.result.top, props.result.order)}
          </div>
        )}
      </div>
    </div>
  );
}

export default ManagementResult;
